import React from 'react'
import PropTypes from 'prop-types'
import { Label, Input } from 'glamorous'

import Text from 'components/common/Text'
import RadioCircle from 'components/settings/RadioCircle'

const Radio = ({ name, value, label, isChecked, isLast, onChange }) => {
  return (
    <Label
      display="flex"
      flexDirection="row"
      alignItems="center"
      WebkitTapHighlightColor="transparent"
      marginBottom={isLast ? 0 : 14}
    >
      <Input
        type="radio"
        name={name}
        value={value}
        checked={isChecked}
        onChange={onChange}
        width={0}
        height={0}
        visibility="hidden"
      />
      <RadioCircle isChecked={isChecked} />
      <Text size={18}>{label}</Text>
    </Label>
  )
}

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  isLast: PropTypes.bool,
  onChange: PropTypes.func
}

Radio.defaultProps = {
  onChange: () => {},
  isLast: false
}

export default Radio



// WEBPACK FOOTER //
// ./src/components/settings/Radio.js